import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-extraneous-dependencies
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
// import { Button } from 'primereact/button';
import { FileInput } from 'components/FormControl';
import { formatFileName } from 'utils/func';
import DownloadOrViewPdf from 'components/DownloadOrViewPdf';

export default function UploadMultipleFile({
  disabled,
  control,
  errors,
  summaryReportAppendixeArray,
  handleDownloadFile,
  // setAppendixFilesDelete,
  // setSummaryReportAppendixeArray,
}) {
  // #region Data
  const { t } = useTranslation();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'appendixFiles',
  });

  // #endregion Data
  return (
    <>
      {!disabled && <h5>{t('projectProposal.researchDescription.otherProofsAndAppendices')}</h5>}
      {fields?.map((item, index) => (
        <div className="relative pl-4" key={item.id}>
          {!disabled && <hr className="border border-1 border-primary my-1" />}
          <span className="font-bold">
            {t('formLayout.numericalOrder')}: {index + 1}
          </span>

          {!disabled && (
            <FileInput
              name={`appendixFiles.${index}`}
              accept=".pdf"
              control={control}
              errors={errors}
              acceptOnly="pdfOnly"
            />
          )}

          {!disabled && (
            <button
              className="p-button p-button-text p-button-icon-only p-0 absolute top-0 right-0 mt-2"
              type="button"
              onClick={() => remove(index)}
              disabled={disabled}
            >
              <i type="button" className="pi pi-times text-red-500 text-xl" />
            </button>
          )}
        </div>
      ))}
      {!disabled && fields?.length < 4 && (
        <div className="pl-4">
          <hr className="border border-1 border-primary mt-1 mb-1" />
          <div className="flex justify-content-center">
            <button
              className="p-button p-button-text p-button-icon-only p-0"
              type="button"
              onClick={() => {
                append({
                  id: uuidv4(),
                  file: null,
                });
              }}
              disabled={disabled}
            >
              <i type="button" className="pi pi-fw pi-plus text-primary text-xl" />
            </button>
          </div>
        </div>
      )}
      <div className="file-appendix-table">
        <table>
          <tbody>
            <tr>
              <td>{summaryReportAppendixeArray?.length !== 0 && 'File đính kèm'}</td>
            </tr>
            {summaryReportAppendixeArray?.map((summaryReportAppendixe) => (
              <tr>
                <td>
                  <DownloadOrViewPdf
                    opts={{ path: summaryReportAppendixe?.fileUrl }}
                    fileName={formatFileName(summaryReportAppendixe?.fileUrl ?? '')}
                    handleDownloadOrView={handleDownloadFile}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

UploadMultipleFile.propTypes = {
  disabled: PropTypes.bool,
  errors: PropTypes.shape({}).isRequired,
  control: PropTypes.shape({}).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  summaryReportAppendixeArray: PropTypes.array.isRequired,
  handleDownloadFile: PropTypes.func,
  // setAppendixFilesDelete: PropTypes.func,
  // setSummaryReportAppendixeArray: PropTypes.func.isRequired,
};

UploadMultipleFile.defaultProps = {
  disabled: false,
  handleDownloadFile: () => null,
  // setAppendixFilesDelete: () => null,
};
